<div class="bg-white" xmlns="http://www.w3.org/1999/html">
  <app-citizen-header>
  </app-citizen-header>
  <app-help-utility [msaadaAiToggle]="msaadaAiToggle"></app-help-utility>

  <div class="w-full ">
    <div class="relative h-[240px] md:h-[280px] w-full  overflow-hidden">
      <img src="/assets/images/dar.jpg"
           alt=""
           class="absolute inset-0 w-full h-full object-cover">
      <div class="infoPicha2"></div>
      <div class="relative z-10 h-full flex  items-center justify-between px-10 md:px-16 w-10/12 mx-auto ">
        <p class="text-xl md:text-4xl leading-relaxed font-semibold w-6/12 ">
          <span
            class="text-secondary-500">{{ "Unaswali kuhusu dirisha la huduma za serikali ?"|concat|translate }}</span>
          <br>
          <span class="text-white"> {{ "Karibu tukuhudumie"|concat|translate }}</span>
        </p>
        <div class="mgQn2">
          <mat-icon svgIcon="majorQuestion"></mat-icon>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-3  grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 w-11/12 mx-auto ">
    <div class="col-span-1 flex flex-col gap-3">
      <ng-container *ngIf="systemContactCenter$ | async as gsd">
        <div class="bg-light_primary px-5 py-4 flex gap-3 rounded-md">
          <img src="/assets/images/new-tgsd-logo.svg"
               alt="{{ gsd.institution?.institutionName }}"
               class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer self-center" />

          <div class="flex flex-col gap-2 flex-grow">
            <div class="text-gray-700 font-bold text-lg">
              {{ gsd.institution?.institutionShortform || "GSD" }}
            </div>

            <div class="text-gray-700 border-b text-lg pb-1 border-secondary-400">
              {{ gsd.institution?.institutionName }}
            </div>

            <div class="grid grid-cols-2 gap-3 text-md mt-1" *ngIf="gsd.schedules?.length">
              <div *ngFor="let sched of sortSchedules(gsd.schedules)">
                <span class="font-bold">{{ sched.weekday }}</span>: {{ sched.startTime }} - {{ sched.endTime }}
              </div>
            </div>

            <div class="grid grid-cols-2 mt-3 gap-1">
              <a
                class="no-underline col-span-1 text-md flex items-center bg-primary-500/80 text-white py-1 px-2"
                [href]="'sms:' + gsd.smsPhone"
                *ngIf="gsd.smsPhone"
              >
                <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="message"></mat-icon>
                <span class="font-semibold text-md">{{ "Tuma ujumbe" | concat | translate }}</span>
              </a>

              <a
                class="no-underline col-span-1 text-md flex items-center bg-primary-500/80 text-white py-1 px-2"
                [href]="'tel:' + gsd.callPhone"
                *ngIf="gsd.callPhone"
              >
                <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="phone-call"></mat-icon>
                <span class="font-semibold text-md">{{ "Piga simu" | concat | translate }}</span>
              </a>

              <div
                class="no-underline col-span-2 text-md flex items-center bg-primary-500/80 text-white py-1 px-2 cursor-pointer"
                (click)="msaadaAiToggle = !msaadaAiToggle"              >
                <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="msaadaAi"></mat-icon>
                <span class="font-semibold text-md">{{ "Msaada Ai" | concat | translate }}</span>
              </div>



            </div>

            <div class="text-gray-700 border-b mt-2 text-lg border-secondary-400">
              {{ "Social Medias" | concat | translate }}
            </div>

            <div class="flex flex-wrap gap-3 mt-2" *ngIf="gsd.socialMedia?.length">
              <ng-container *ngFor="let sm of gsd.socialMedia">
                <a
                  *ngIf="sm.url"
                  class="no-underline text-primary-400 flex items-center gap-1 hover:underline"
                  [href]="sm.url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <mat-icon [svgIcon]="getSocialMediaIcon(sm.platform)"></mat-icon>
                  <span>{{ sm.handle || sm.title }}</span>
                </a>
                <div *ngIf="!sm.url" class="text-primary-400 flex items-center gap-1">
                  <mat-icon [svgIcon]="getSocialMediaIcon(sm.platform)"></mat-icon>
                  <span>{{ sm.handle || sm.title }}</span>
                </div>
              </ng-container>
            </div>

          </div>
        </div>
      </ng-container>

      <div class="mb-2 flex flex-col gap-3" *ngIf="faqs$ | async as faqs">
        <div class="w-full px-2 py-3 text-lg bg-light_primary rounded-lg">
          {{ "Maswali yaliyoulizwa mara nyingi"|concat|translate }}
        </div>
        <mat-accordion displayMode="flat" class="!shadow-none">
          <mat-expansion-panel
            hideToggle
            class="bg-white !shadow-none border-b border-b-secondary-200  {{ openedFaq === idx ? 'opened' : '' }}"
            (expandedChange)="changePanelState()"
            *ngFor="let faq of faqs let idx = index">
            <mat-expansion-panel-header class="intro-y">
              <mat-panel-title>
                <div> {{ faq?.questionName }} ?</div>
              </mat-panel-title>
              <div class="flex items-center justify-center py-1">
                <div class="rounded-full w-8 h-8  flex items-center justify-center "
                     *ngIf="openedFaq !== idx; else opened">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
                <ng-template #opened>
                  <div class="rounded-full w-8 h-8  flex items-center justify-center ">
                    <mat-icon>keyboard_arrow_up</mat-icon>
                  </div>
                </ng-template>
              </div>
            </mat-expansion-panel-header>
            <div class="text-justify text-gray-500 flex gap-2 px-6 pb-3">
              <div> {{ faq?.questionAnswer }}</div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

      </div>

    </div>

    <div class="col-span-1 md:col-span-2 grid lg:grid-cols-2 grid-cols-1 gap-4 p-3" appSequentialAnimate
         direction="vertical">
      <div class="flex items-center  lg:col-span-2 col-span-1 justify-between border-b-2 border-yellow-400 pb-2 mb-6">
        <div class="text-xl text-primary-600">{{ "Call Centre"|concat|translate }}</div>

        <div class="w-5/12 flex items-center border border-primary/90 p-2.5 rounded-sm">
          <input
            class="w-full outline-none bg-transparent text-black placeholder:text-gray-300"
            matInput
            placeholder="{{'Tafuta '|concat|translate}}">
          <mat-icon svgIcon="landingSearch" class="text-gray-400" style="height:20px;width:20px"></mat-icon>
        </div>
      </div>
      <ng-container *ngIf="contactCenters$ | async as contactCenters">
        <ng-container *ngFor="let center of contactCenters">
          <div class="border border-primary/90 p-3 flex gap-2 col-span-1">
            <img src="/assets/images/emblem.png"
                 alt="{{ center.institution?.institutionName }}"
                 class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer self-baseline"/>

            <div class="flex flex-col gap-2 w-full">
              <div class="text-gray-700 font-semibold text-lg">
                {{ center.institution?.institutionShortform || center.institution?.institutionName }}
              </div>

              <div class="text-gray-600 border-b text-lg border-secondary-400">
                {{ center.institution?.institutionName }}
              </div>

              <div class="grid grid-cols-2 gap-3 text-md mt-1" *ngIf="center.schedules?.length">
                <div *ngFor="let sched of sortSchedules(center.schedules)">
                  <span class="font-bold">{{ sched.weekday }}</span>: {{ sched.startTime }} - {{ sched.endTime }}
                </div>
              </div>
              <div class="grid grid-cols-2 gap-1 mt-1">
                <a
                  class="no-underline col-span-1 text-md flex items-center bg-primary-500/80 text-white py-1 px-2"
                  [href]="'sms:' + center.smsPhone"
                  *ngIf="center.smsPhone"
                >
                  <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="message"></mat-icon>
                  <span class="font-semibold text-md">{{ "Tuma ujumbe" | concat | translate }}</span>
                </a>

                <a
                  class="no-underline col-span-1 text-md flex items-center bg-primary-500/80 text-white py-1 px-2"
                  [href]="'tel:' + center.callPhone"
                  *ngIf="center.callPhone"
                >
                  <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="phone-call"></mat-icon>
                  <span class="font-semibold text-md">{{ "Piga simu" | concat | translate }}</span>
                </a>
              </div>
              <div class="text-gray-700 border-b mt-2 text-lg border-secondary-400">
                {{ "Social Medias" | concat | translate }}
              </div>
              <div class="flex flex-wrap gap-3 mt-2" *ngIf="center.socialMedia?.length">
                <ng-container *ngFor="let sm of center.socialMedia">
                  <a
                    *ngIf="sm.url"
                    class="no-underline text-primary-400 flex items-center gap-1 hover:underline"
                    [href]="sm.url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <mat-icon [svgIcon]="getSocialMediaIcon(sm.platform)"></mat-icon>
                    <span>{{ sm.handle || sm.title }}</span>
                  </a>
                  <div *ngIf="!sm.url" class="text-primary-400 flex items-center gap-1">
                    <mat-icon [svgIcon]="getSocialMediaIcon(sm.platform)"></mat-icon>
                    <span>{{ sm.handle || sm.title }}</span>
                  </div>
                </ng-container>
              </div>

            </div>
          </div>
        </ng-container>
      </ng-container>

    </div>
  </div>


  <app-portal-footer></app-portal-footer>

</div>
